<div *ngIf="productionOrder && products.length" class="border-x w-full h-full">
  <div class="absolute right-3 z-10">
    <dx-button (onClick)="changeFullscreen()" [icon]="!fullscreen ? 'fullscreen' : 'fullscreen_exit'" />
    <dx-button (onClick)="close()" icon="cancel" />
  </div>
  <div *ngIf="langCode$ | async as langCode" class="flex h-full border-t">
    <div class="border w-1/5 overflow-y-auto pb-2">
      <div class="row m-4">
        <div class="flex justify-between">
          <div class="font-bold text-lg ">{{productionOrder.number}}</div>
          <dx-button icon="edit" (onClick)="editProductionOrder(productionOrder.id)" />
        </div>
        <p>Inici: {{productionOrder.startDate | date:'dd/MM/yyyy HH:mm:ss'}}</p>
        <p>Fi: {{productionOrder.endDate | date:'dd/MM/yyyy HH:mm:ss'}}</p>
        <br>
        <p class="font-bold border-b">Producte</p>
        <div class="pt-4">
          <p class="font-bold" *ngIf="OFProduct !== undefined">{{OFProduct.code}}</p>
          <p *ngIf="OFProduct !== undefined">{{OFProduct.name}}</p>
          <p>
            <span>{{$any(productionOrder).quantity}}</span>
            <span *ngIf="OFProduct !== undefined">{{OFProduct.stockFormatCode}}</span>
          </p>
        </div>
      </div>
      <div class="row m-4" *ngIf="OFCoProducts.length > 0">
        <p class="font-bold border-b">Co-productes</p>
        <div class="pt-4" *ngFor="let coProduct of OFCoProducts">
          <p class="font-bold">{{coProduct.code}}</p>
          <p class="font-bold">{{coProduct.name}}</p>
          <p>{{coProduct.stockFormatCode}}</p>
        </div>
      </div>
      <div class="row m-4" *ngIf="OFByProducts.length > 0">
        <p class="font-bold border-b">By-productes</p>
        <div class="pt-4" *ngFor="let byProduct of OFByProducts">
          <p class="font-bold">{{byProduct.code}}</p>
          <p class="font-bold">{{byProduct.name}}</p>
          <p>{{byProduct.stockFormatCode}}</p>
        </div>
      </div>
    </div>
    <dx-tab-panel class="w-full h-full">
      <dxi-item [title]="'common.operations' | translate | ucfirst">
        <div class="w-full p-3 gap-3">
          <div *ngFor="let operation of operationsList"
                class="card my-1 p-3"
                [ngClass]="{'border bg-light-theme-color': operationId === operation.id}"
          >
            <div class="title mt-">{{ operation.name }}</div>
            <div class="body">
              <div class="labeled-items inline">
                <div class="item">
                  <div class="label">{{ 'common.workcenters' | translate | ucfirst }}</div>
                  <div class="value">{{ operation.workcenters }}</div>
                </div>
                <div class="item">
                  <div class="label">{{ 'common.start' | translate | ucfirst }}</div>
                  <div class="value">{{ operation.start | date:'short':undefined:langCode }}</div>
                </div>
                <div class="item">
                  <div class="label">{{ 'common.end' | translate | ucfirst }}</div>
                  <div class="value">{{ operation.end | date:'short':undefined:langCode }}</div>
                </div>
                <div class="item">
                  <div class="label">{{ 'common.duration' | translate | ucfirst }}</div>
                  <div class="value">{{ operation.duration | timeElapsed }}</div>
                </div>
              </div>
            </div>
            <!-- <div class="">{{ operation.dependencies | json }}</div> -->
          </div>
        </div>
      </dxi-item>
      <!-- * GRAPHIC SECTION -->
      <!-- <dxi-item>
          <div *ngFor="let product of products" class="flex">
            <div class="px-3 self-center max-w-44">{{ product.name }}</div>
            <app-chart-stock-entries class="flex-1 "
              [product]="product"
              [startDate]="startDate!"
              [endDate]="endDate!"
            />
          </div>
      </dxi-item> -->
    </dx-tab-panel>
  </div>
</div>
